// @ts-nocheck
import React from 'react';
import SVG from 'react-inlinesvg';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { MoreLinkType } from 'types';

import { TypeOfApplicationLink } from '@kaltura-ott/tvpil';

import chevronIcon from 'assets/images/chevron.svg';
import { FROM_REFERENCE_ID } from 'consts';
import { useWidgetContext } from 'context/widgetProvider/widgetProvider';
import { useMenuStore, usePageId, useSearchParam } from 'hooks';
import { findMenuItems, getGridPageLink } from 'utils';

import styles from './MoreButton.module.scss';

interface Props {
  data: MoreLinkType;
}

type ConditionalProps =
  | { to: string; href?: never }
  | { href: string; to?: never };

const MoreButton = ({ data }: Props) => {
  const menuStore = useMenuStore();
  const pageId = usePageId();
  const { type } = useWidgetContext();
  const referenceId = useSearchParam(FROM_REFERENCE_ID) || pageId;
  const intl = useIntl();
  const buttonLabel = intl.formatMessage({ defaultMessage: 'More button', id: 'Rail.moreButton' });
  const isLinkInMenu = !!findMenuItems(menuStore, data.inAppLink).itemById;
  const link = getGridPageLink({
    linkType: data.linkType,
    inAppLink: data.inAppLink,
    subtype: type.toLocaleLowerCase(),
    id: data.referenceId,
    dataLink: data.link,
    referenceId: !isLinkInMenu ? referenceId: '',
  });

  let Tag: typeof Link | string = Link;
  let conditionalProps: ConditionalProps = {
    to: link,
  };

  if (data.linkType === TypeOfApplicationLink.external) {
    Tag = 'a';
    conditionalProps = {
      href: link,
    };
  }

  return (
    <div className={styles.moreButton}>
      <Tag tabIndex={0} role='button' {...conditionalProps} aria-label={buttonLabel}>
        <span aria-hidden>
          {buttonLabel}
          <SVG src={chevronIcon} />
        </span>
      </Tag>
    </div>
  );
};

export default MoreButton;
